module.exports = __webpack_public_path__ + "img/tjggyh.236a00cf.png";